<template>
  <div>
    <div class="wGC-categoryArea">
      <!-- 搜索区 -->
      <div class="wETJRFSerach-area" style="margin-bottom: 20px; flex-wrap: wrap;">
        <div style="display: flex; align-items: center; margin-bottom: 15px; width: 100%;">
          <el-date-picker
            v-model="searchDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="margin-right: 15px;"
          >
          </el-date-picker>
          <el-select 
            v-if="!isStoreAccount"
            v-model="searchStoreId" 
            placeholder="请选择门店" 
            style="width: 200px; margin-right: 15px;"
            clearable
            filterable
          >
            <el-option
              v-for="item in storeList"
              :key="item.id"
              :label="item.storeName"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </div>
        <!-- 统计区 -->
        <div v-if="totalPrice !== null" style="font-size: 13px; display: flex; align-items: center; gap: 10px; flex-wrap: nowrap; white-space: nowrap;">
          <span>实际结算金额：<span style="color: #f56c6c; font-weight: bold; font-size: 14px;">¥ {{ totalPrice }}</span></span>
          <span v-if="orderTotalAmount !== null">订单总金额：<span style="color: #f56c6c; font-weight: bold; font-size: 14px;">¥ {{ orderTotalAmount }}</span></span>
          <span v-if="amountPaid !== null">实收金额：<span style="color: #f56c6c; font-weight: bold; font-size: 14px;">¥ {{ amountPaid }}</span></span>
          <span v-if="totserviceFee !== null">第三方服务费：<span style="color: #f56c6c; font-weight: bold; font-size: 14px;">¥ {{ totserviceFee }}</span></span>
          <span v-if="totalValueAddedIncome !== null">增值收益：<span style="color: #f56c6c; font-weight: bold; font-size: 14px;">¥ {{ totalValueAddedIncome }}</span></span>
          <span v-if="totalChanelCommission !== null">{{ getChannelCommissionLabel() }}：<span style="color: #f56c6c; font-weight: bold; font-size: 14px;">¥ {{ totalChanelCommission }}</span></span>
          <span v-if="totalMasterCommission !== null">师徒制佣金：<span style="color: #f56c6c; font-weight: bold; font-size: 14px;">¥ {{ totalMasterCommission }}</span></span>
        </div>
      </div>

      <!-- 表格数据区 -->
      <div class="wGC-categoryList">
        <div class="wGLG-table">
          <el-table :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column label="订单编号" prop="id" width="200" align="center"></el-table-column>
            <el-table-column label="门店名称" min-width="200" align="center">
              <template slot-scope="scope">
                {{ scope.row.orderName ? scope.row.orderName.replace(/^订单：/, '') : '' }}
              </template>
            </el-table-column>
            <!-- <el-table-column label="店铺ID" prop="storeId" width="80" align="center"></el-table-column>
            <el-table-column label="用户ID" prop="userId" width="80" align="center"></el-table-column> -->
            <el-table-column label="订单总金额" prop="totalMoney" width="100" align="center"></el-table-column>
            <el-table-column label="实收金额" prop="realMoney" width="100" align="center"></el-table-column>
            <el-table-column label="第三方服务费" prop="serviceFee" width="110" align="center"></el-table-column>
            <el-table-column label="增值收益" prop="valueAddedIncome" width="110" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.valueAddedIncome !== null && scope.row.valueAddedIncome !== undefined">{{ scope.row.valueAddedIncome }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column :label="getChannelCommissionLabel()" prop="channelCommission" width="140" align="center"></el-table-column>
            <el-table-column label="师徒制佣金" prop="masterCommission" width="110" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.masterCommission !== null && scope.row.masterCommission !== undefined">{{ scope.row.masterCommission }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="实际结算金额" prop="actualSettlementAmount" width="120" align="center">
              <template slot-scope="scope">
                <span style="color: #f56c6c; font-weight: bold;">{{ scope.row.actualSettlementAmount }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="订单类型(atype)" prop="atype" width="120" align="center"></el-table-column> -->
            <el-table-column label="支付时间" prop="payTime" width="160" align="center"></el-table-column>
            <!-- <el-table-column label="创建时间" prop="createTime" width="160" align="center"></el-table-column> -->
          </el-table>
        </div>

        <!-- 分页 -->
        <div class="wPagination" style="margin-top: 20px; text-align: center;">
          <el-pagination 
            background 
            layout="total, sizes, prev, pager, next, jumper" 
            :current-page="page" 
            :page-size="limit" 
            :total="total" 
            :page-sizes="[10, 20, 50, 100]"
            @current-change="handleCurrentChange" 
            @size-change="handleSizeChange">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { storeBillListApi, store_storeList, getStoreManagerListApi, getHighestIdentityByStoreId } from '@/network/wApi.js'

export default {
  name: 'StoreBillList',
  data() {
    return {
      searchDate: [], // [开始时间, 结束时间]
      searchStoreId: '',
      storeList: [], // 门店列表选项
      tableData: [],
      loading: false,
      page: 1,
      limit: 10,
      total: 0,
      totalPrice: null,
      orderTotalAmount: null,
      amountPaid: null,
      totserviceFee: null,
      totalChanelCommission: null,
      totalMasterCommission: null,
      totalValueAddedIncome: null,
      isStoreAccount: false, // 是否为门店账号
      storeTypeName: '' // 门店类型名称（用于拼接待发获客佣金标题）
    }
  },
  created() {
    this.checkPermission()
  },
  methods: {
    // 检查权限
    checkPermission() {
      const userInfo = JSON.parse(localStorage.getItem('USER_INFO'))
      // 兼容所有非超管情况，或从门店管理员列表接口中查其是否有权限管理特定门店
      let userId = '';
      if (userInfo) {
        userId = userInfo.id || '';
      }
      
      // 调用专门的管理员所属门店接口来判断
      getStoreManagerListApi({ userId }).then(res => {
        let stores = [];
        if (res && Array.isArray(res)) {
          stores = res;
        } else if (res && res.records && Array.isArray(res.records)) {
          stores = res.records;
        }

        // 无论如何，直接用当前登录用户的 ID 获取最高身份
        // 因为 "用户的最高身份" 应该是看当前登录的人是谁，而不是看他管理的门店是谁的
        // 初始不调用 fetchStoreIdentity，保持 storeTypeName 为空，显示"代发获客佣金"
        // 只有点击查询按钮时才调用（见 handleSearch）

        // 判断门店账号的最新逻辑：如果 identityName 等于 "门店"，则认为是门店账号
        // userInfo.identityName == "门店" 这个字段可以准确区分
        if (userInfo && userInfo.identityName === "门店" && stores.length > 0) {
          this.isStoreAccount = true
          this.searchStoreId = stores[0].id
          this.storeList = stores
        } else if (userInfo && userInfo.roleId != 1 && stores.length > 0 && !userInfo.identityName) {
           // 兼容旧逻辑
          this.isStoreAccount = true
          this.searchStoreId = stores[0].id
          this.storeList = stores
        } else {
          this.isStoreAccount = false
          // 如果是管理员，获取所有店
          this.getStoreList()
        }
        
        // 判断完毕后发起列表请求
        this.getList()
      }).catch(err => {
        console.error('获取权限或门店信息失败:', err)
        // 兜底：如果没有通过管理员判断，默认按旧的管理员放行
        this.getStoreList()
        // 兜底时不调用 fetchStoreIdentity，让 storeTypeName 保持为空
        this.getList()
      })
    },
    // 获取门店等级名称
    fetchStoreIdentity(storeId, storeName) {
      console.log('--- fetchStoreIdentity is called with storeId: ', storeId, 'storeName:', storeName);

      if (!storeId) {
         console.warn('--- fetchStoreIdentity: storeId is empty!');
         this.storeTypeName = ''
         return
      }

      getHighestIdentityByStoreId(storeId).then(res => {
        console.log('--- fetchStoreIdentity called with storeId:', storeId);
        console.log('--- fetchStoreIdentity response:', res);
        console.log('--- fetchStoreIdentity res.identity:', res && res.identity);
        // identity 编码映射表
        const identityMap = {
          'CN': '渠道服务商',
          'DN': '董事',
          'QN': '轻创代理合伙人',
          'KN': '开店连锁合伙人',
          'YC': '云仓代理合伙人',
          'QX': '区县代理合伙人',
          'SD': '市代理合伙人',
          'SJ': '省级分公司合伙人',
          'SN': '社区团长'
        }
        const cleanupIdentityName = (name) => {
          if (!name) return ''
          return String(name).replace(/服务商|合伙人|代理|团长/g, '').trim()
        }
        const pickStoreTypeName = (source, fallbackStoreName) => {
          if (!source) return this.getStoreTypeFromName(fallbackStoreName) || '门店'
          const codeName = source.identity && identityMap[source.identity] ? identityMap[source.identity] : ''
          const apiName = source.identityName || source.name || source.typeName || ''
          if (source.identity === 'SN') return '社区'
          const fromCode = cleanupIdentityName(codeName)
          if (fromCode) return fromCode
          const fromApi = cleanupIdentityName(apiName)
          if (fromApi) return fromApi
          return this.getStoreTypeFromName(fallbackStoreName) || '门店'
        }
        // 优先使用 identity 字段判断
        // 如果名字带"服务商"或"合伙人"，去掉这些字，剩下的部分 + "门店获客佣金"
        // SN身份特殊处理：显示"社区门店获客佣金"
        // 其他身份（如VIP等）保持为空，显示"代发获客佣金"
        // 改为“尽量非空”：优先 identity 编码，其次接口返回名称，再用门店名关键词，最后兜底"门店"
        this.storeTypeName = pickStoreTypeName(res, storeName)
        console.log('--- storeTypeName updated to:', this.storeTypeName);
      }).catch(err => {
        console.error("获取门店等级失败:", err)
        // 异常时也保持非空
        this.storeTypeName = this.getStoreTypeFromName(storeName) || '门店'
      })
    },
    // 获取门店下拉列表 (仅管理员调用)
    getStoreList() {
      store_storeList({
        'pageModel.pageNo': 1,
        'pageModel.pageSize': 1000
      }).then(res => {
        console.log('--- getStoreList response:', res);
        this.storeList = res.records || res || []
        console.log('--- storeList after set:', this.storeList);
      }).catch(err => {
        console.error('获取门店列表失败:', err)
      })
    },
    // 根据 atype 设置门店类型名称 (已废弃，直接使用用户的 identityName)
    setStoreTypeName(atype) {
      this.storeTypeName = ''
    },
    // 生成“获客佣金”标题，避免“门店门店获客佣金”这类重复展示
    getChannelCommissionLabel() {
      const name = (this.storeTypeName || '').trim()
      if (!name) return '代发获客佣金'
      if (name.includes('门店')) return name + '获客佣金'
      return name + '门店获客佣金'
    },
    // 获取列表数据
    getList() {
      this.loading = true
      let params = {
        'pageModel.pageNo': this.page,
        'pageModel.pageSize': this.limit
      }
      
      if (this.searchStoreId) {
        params.storeId = this.searchStoreId
      }
      if (this.searchDate && this.searchDate.length === 2) {
        // 后端是Date类型，直接传 yyyy-MM-dd 或带时分秒看后端需求
        params.start = this.searchDate[0] + ' 00:00:00'
        params.end = this.searchDate[1] + ' 23:59:59'
      }

      storeBillListApi(params).then(res => {
        this.loading = false
        console.log("分账列表返回:", res) // 添加打印排查
        
        // 兼容处理：如果后端修改后，res.data 还是对象，那么外层的 count 就可能在 res 里，也可能在 res.data 里
        let resData = res.data || {}
        // 尝试从最外层或者 data 层获取 count，优先取 count，如果没有再取 total
        let totalCount = res.count !== undefined && res.count !== null ? res.count : 
                        (resData.count !== undefined && resData.count !== null ? resData.count : 
                        (resData.total !== undefined ? resData.total : 0))
        
        // 提取汇总字段
        const extractSummary = (source) => {
          this.totalPrice = source.totalPrice !== undefined ? source.totalPrice : null;
          this.orderTotalAmount = source.orderTotalAmount !== undefined ? source.orderTotalAmount : null;
          this.amountPaid = source.amountPaid !== undefined ? source.amountPaid : null;
          this.totserviceFee = source.totserviceFee !== undefined ? source.totserviceFee : null;
          this.totalChanelCommission = source.totalChanelCommission !== undefined ? source.totalChanelCommission : null;
          this.totalMasterCommission = source.totalMasterCommission !== undefined ? source.totalMasterCommission : null;
          this.totalValueAddedIncome = source.totalValueAddedIncome !== undefined ? source.totalValueAddedIncome : null;
        }

        if (resData.orderStaticList) {
          this.tableData = resData.orderStaticList || []
          this.total = totalCount || this.tableData.length
          extractSummary(resData)
        } else if (resData.records) {
          this.tableData = resData.records
          this.total = totalCount || this.tableData.length
          extractSummary(resData)
        } else if (res.orderStaticList) { // 有时响应拦截器直接返回了 data 对象本身
          this.tableData = res.orderStaticList || []
          this.total = res.count !== undefined && res.count !== null ? res.count : this.tableData.length
          extractSummary(res)
        } else {
          this.tableData = resData || []
          this.total = totalCount || this.tableData.length
          extractSummary(resData)
        }
      }).catch(err => {
        this.loading = false
        console.error('获取分账列表失败:', err)
      })
    },
    // 搜索
    handleSearch() {
      if (this.searchStoreId) {
        const currentStore = this.storeList.find(item => item.id === this.searchStoreId)
        console.log('--- handleSearch currentStore:', currentStore);
        console.log('--- storeList:', this.storeList);
        if (currentStore) {
          // 直接传 storeId
          const storeId = this.searchStoreId
          console.log('--- handleSearch storeId:', storeId);
          // 传入门店名称作为备用
          this.fetchStoreIdentity(storeId, currentStore.storeName)
        } else {
          console.log('--- handleSearch: currentStore not found');
          this.storeTypeName = ''
        }
      } else {
        this.storeTypeName = ''
      }
      this.page = 1
      this.getList()
    },
    // 根据门店名称关键词获取门店类型（去掉"服务商"和"合伙人"）
    getStoreTypeFromName(storeName) {
      if (!storeName) return ''
      if (storeName.includes('云仓')) return '云仓'
      if (storeName.includes('渠道')) return '渠道'
      if (storeName.includes('连锁')) return '连锁'
      if (storeName.includes('社区团长')) return '社区'
      if (storeName.includes('服务商')) return storeName.replace(/服务商|合伙人/g, '')
      if (storeName.includes('合伙人')) return storeName.replace(/服务商|合伙人/g, '')
      return ''
    },
    // 重置
    resetSearch() {
      this.searchDate = []
      // 如果是门店账号，重置时不清除它的 storeId
      if (!this.isStoreAccount) {
        this.searchStoreId = ''
      }
      this.storeTypeName = '' // 重置时清空身份名称，恢复显示"代发获客佣金"
      this.page = 1
      this.getList()
    },
    // 分页改变
    handleCurrentChange(val) {
      this.page = val
      this.getList()
    },
    // 每页条数改变
    handleSizeChange(val) {
      this.limit = val
      this.page = 1
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped>
@import "@/assets/css/publicStyle.less";
.wGC-categoryArea {
  display: block;
  width: 100%;
  padding: 20px 16px;
  box-sizing: border-box;
  background-color: #ffffff;
}
.wETJRFSerach-area {
  display: flex;
  align-items: center;
}
</style>
